export default "__VITE_ASSET__B_v610t8__"